import styles from "./terms.module.scss";

/**
 * Body of the Privacy Policy document, shared between the standalone
 * /privacy-policy page and the in-settings Legal modal.
 */
export const PrivacyPolicyContent = () => (
	<>
		<p>
			Eko Power app ("we", "our", or "us") is a consumer-facing energy app developed and operated by <strong>Beacon Power Services</strong>. This privacy policy
			explains how we collect, use, share, and protect your information when you use our mobile application on Android or iOS.
		</p>{" "}
		<ol className={styles.orderedList}>
			<li>
				<h2>Information We Collect</h2>
				<p>When you use Eko Power app, we may collect the following types of personal and usage data:</p>
				<br />
				<ul className={styles.unorderedList}>
					<li>
						<strong> Personal Information:</strong> Name, email address, phone number, location.
					</li>
					<li>
						<strong> Utility Data:</strong> Meter number, meter details, energy consumption data across various sources.
					</li>
					<li>
						<strong> Payment & Financial Information:</strong> Payment method details, billing history, and financial data required for asset financing.
					</li>
					<li>
						<strong> Device Information:</strong> Device type, operating system, and unique identifiers.
					</li>
					<li>
						<strong> Account Information:</strong> Login credentials and preferences associated with your account.
					</li>
				</ul>
			</li>
			<li>
				<h2>How We Use Your Information</h2>
				<p>We use the information we collect to:</p>
				<br />
				<ul className={styles.unorderedList}>
					<li>Enable utility bill payments and monitor payment history.</li>
					<li>Track and display energy consumption data and insights.</li>
					<li>Provide access to renewable energy products and financing or subscription options.</li>
					<li>Offer customer support and account management.</li>
					<li>Comply with legal obligations and enforce our terms of service.</li>
				</ul>
			</li>
			<li>
				<h2>Third-Party Services</h2>
				<p>We work with third-party services and SDKs for:</p>
				<br />
				<ul className={styles.unorderedList}>
					<li>
						<strong>Payment Processing</strong> (e.g., Paystack, Flutterwave)
					</li>
					<li>
						<strong>Identity Verification</strong>
					</li>
					<li>
						<strong>Analytics and Infrastructure</strong>
					</li>
				</ul>
				<br />
				<p>These services may collect information in accordance with their own privacy policies.</p>
			</li>
			<li>
				<h2>Data Sharing</h2>
				<p>We may share your information with:</p>
				<br />
				<ul className={styles.unorderedList}>
					<li>
						<strong>Utility Providers</strong> (e.g., Paystack, Flutterwave) to verify meter information and process electricity payments.
					</li>
					<li>
						<strong>Payment Partners and Financial Institutions</strong> for processing transactions and offering financing options.
					</li>
					<li>
						<strong>Service Providers</strong> assisting with analytics, cloud infrastructure, or technical support.
					</li>
				</ul>
				<br />
				<p>We do not sell your personal data to third parties.</p>
			</li>
			<li>
				<h2>User Accounts and Data Control</h2>
				<p>Users must create an account to access Eko Power app's features. You have full control over your data and may:</p>
				<br />
				<ul className={styles.unorderedList}>
					<li>
						<strong>Update</strong> your account information at any time.
					</li>
					<li>
						<strong>Request to close your account,</strong> after which your personal data will be deleted in accordance with applicable laws.
					</li>
				</ul>
				<br />
				<p>
					To request account closure or data deletion, contact us at: <strong>support@bpsafrica.com</strong>
				</p>
			</li>
			<li>
				<h2>Security</h2>
				<p>
					We implement appropriate technical and organizational measures to safeguard your data, including encryption, secure data storage, and access controls.
				</p>
			</li>
			<li>
				<h2>Children's Privacy</h2>
				<p>Eko Power app is not intended for use by individuals under the age of 13. We do not knowingly collect personal data from children.</p>
			</li>
			<li>
				<h2>Changes to This Policy</h2>
				<p>We may update this privacy policy from time to time. If significant changes are made, we will notify users within the app or via email.</p>
			</li>
			<li>
				<h2>Contact Us</h2>
				<p>If you have any questions about this Privacy Policy or your personal data, you may contact us at:</p>
				<br />
				<p>
					<strong>Beacon Power Services</strong>
				</p>
				<p>Email: support@bpsafrica.com</p>
				<p>Address: 12a Talabi Street, Adeniyi Jones, Ikeja, Lagos.</p>
			</li>
		</ol>
	</>
);

export default PrivacyPolicyContent;
